import type { ChangeEvent } from 'react';
import dayjs from 'dayjs';
import type { KidCostVariables } from '../../../../../api/kids/kids.routes';

/** Backend stores percentages as decimals (1% = 0.01); forms show human-readable values (1% = 1). */
export const DISPLAY_MULTIPLIER = 100;

export const PERCENTAGE_PLACEHOLDER = 'e.g. 1.07';

export const toDisplayCost = (
  backendValue: number | null | undefined,
): string =>
  backendValue != null ? String(backendValue * DISPLAY_MULTIPLIER) : '';

export const toBackendCost = (displayValue: string): number =>
  parseFloat(displayValue) / DISPLAY_MULTIPLIER;

export function getKidCostLastSavedAt(
  costVariables: KidCostVariables | null | undefined,
): string | null {
  return costVariables?.timestamp ?? null;
}

export function formatKidCostSavedDate(
  timestamp: string | null | undefined,
): string {
  if (!timestamp) return '—';
  const parsed = dayjs(timestamp);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : timestamp.slice(0, 10);
}

export function formatKidCostSavedTimestamp(
  timestamp: string | null | undefined,
): string {
  if (!timestamp) return '—';
  const parsed = dayjs(timestamp);
  return parsed.isValid()
    ? parsed.format('YYYY-MM-DD HH:mm:ss')
    : timestamp;
}

export const validateCostField = (
  value: string,
  _label: string,
  required: boolean,
): true | string => {
  if (!required) return true;
  const n = Number(value);
  if (value.trim() === '') return 'Required';
  if (Number.isNaN(n)) return 'Must be a valid number';
  if (n < 0) return 'Cannot be negative';
  return true;
};

export const numericInputOnChange = (e: ChangeEvent<HTMLInputElement>) => {
  const v = e.target.value;
  if (v === '' || /^\d*\.?\d*$/.test(v)) return v;
  e.preventDefault();
};
